import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import CountdownTimer from '@/components/CountdownTimer';
import { Badge } from '@/components/ui/badge';
import { ArrowRight } from 'lucide-react';

export default function DropCard({ drop, index = 0 }) {
  const isLive = drop.status === 'live';
  const isUpcoming = drop.status === 'upcoming';

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: index * 0.1 }}
    >
      <Link to={`/drops/${drop.drop_id}`} data-testid={`drop-card-${drop.drop_id}`}>
        <div className="relative overflow-hidden bg-muted/30 border border-border/40 hover:border-primary/50 transition-all duration-300 group rounded-sm">
          <div className="aspect-[16/10] overflow-hidden relative">
            <img
              src={drop.image_url}
              alt={drop.name}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
            <div className="absolute top-3 left-3">
              {isLive && (
                <Badge className="bg-accent text-accent-foreground font-bold text-xs rounded-sm px-2 py-0.5 uppercase tracking-wider">
                  <span className="w-1.5 h-1.5 rounded-full bg-accent-foreground mr-1.5 inline-block live-pulse" />
                  LIVE
                </Badge>
              )}
              {isUpcoming && (
                <Badge className="bg-primary/20 text-primary font-bold text-xs rounded-sm px-2 py-0.5 uppercase tracking-wider border border-primary/30">
                  UPCOMING
                </Badge>
              )}
            </div>
          </div>
          <div className="p-4">
            <h3 className="font-display font-bold text-lg mb-1 group-hover:text-primary transition-colors duration-200">
              {drop.name}
            </h3>
            <p className="text-sm text-muted-foreground line-clamp-2 mb-3">{drop.description}</p>
            <div className="flex items-center justify-between">
              {isUpcoming && (
                <CountdownTimer targetDate={drop.release_date} />
              )}
              {isLive && (
                <span className="text-xs text-accent font-bold uppercase tracking-wider">Shop Now</span>
              )}
              <ArrowRight className="w-4 h-4 text-muted-foreground group-hover:text-primary group-hover:translate-x-1 transition-all duration-200" />
            </div>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
